<script setup lang="ts">
import { computed } from "vue";
import DRBtn from "@/components/UI/DRBtn.vue";
import type { Article } from "@/types/articles.types";

const props = defineProps<{
  article: Article;
  modelValue: boolean;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: boolean): void;
}>();

const show = computed({
  get: () => props.modelValue,
  set: (value: boolean) => {
    emit("update:modelValue", value);
  },
});
</script>

<template>
  <el-dialog
    v-model="show"
    :title="article.title"
    width="90%"
    append-to-body
    top="1vh"
  >
    <div class=" " style="max-height: 70vh; overflow-y: auto">
      <template v-for="(item, index) in article.items" :key="index">
        <p v-if="item.type === 'paragraph'">{{ item.content }}</p>
        <h6 v-if="item.type === 'title'" class="pt-3">{{ item.content }}</h6>
      </template>
    </div>
    <template #footer>
      <div class="d-flex gap-2 justify-content-end">
        <DRBtn
          variant="primary"
          @click="show = false"
          :label="$t('close')"
          class="px-5"
        >
        </DRBtn>
      </div>
    </template>
  </el-dialog>
</template>

<style lang="scss" scoped></style>
